module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-13-d7889ee13c7b171a70d2fa37e789180c.png";